import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { AddStaff } from "../../CrudOperations/PostOperation";
import { updateStaffInDataBase } from "../../CrudOperations/Update&Edit";
import {
  getCommunities,
  getSkillList,
} from "../../CrudOperations/GetOperation";

const AddStaffModal = ({ closeModal, onSubmit, Staff, onUpdate }) => {
  const [fullName, setFullName] = useState(Staff ? Staff.FullName : "");
  const [contact, setContact] = useState(Staff ? Staff.ContactNo : "");
  const [Gender, setGender] = useState(Staff ? Staff.Gender : "Male");

  const [department, setDepartment] = useState(Staff ? Staff.Department : "");
  const [designation, setDesignation] = useState(
    Staff ? Staff.Designation : ""
  );
  const [base64Image, setBase64Image] = useState("");
  const [address, setAddress] = useState(Staff ? Staff.Address : "");
  const [isAvailable, setisAvailable] = useState(Staff ? Staff.isAvailable : "");
  const [CommunityId, setCommunityId] = useState(Staff ? Staff.isAvailable : "");

  const [previewUrl, setPreviewUrl] = useState(null);
  const [image, setImage] = useState(Staff ? Staff.StaffImage : "");
  const [errors, setErrors] = useState({ mobile_image: "" });
  const [communityList, setCommunityList] = useState([]);
  const [SkillList, setSkillList] = useState([]);

  const [NoOfSkills, setNoOfSkills] = useState(Staff?.NoOfSkills || "");

  const [DeputationSkills, setDeputationSkills] = useState([]); // Array of selected skills

  useEffect(() => {
    const fun = async () => {
      const response = await getCommunities();
      console.log(response);

      if (response.data.length > 0) {
        setCommunityList(response.data);
      }

      const responsegetSkillList = await getSkillList();
      console.log(responsegetSkillList);

      if (responsegetSkillList.data.Message === "Success") {
        console.log(responsegetSkillList);
        setSkillList(responsegetSkillList.data.Data);
      } else {
        toast.error(responsegetSkillList.data.ServerMessage);
      }
    };

    fun();
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    console.log(base64Image);
    console.log(Staff);

    if (!Staff) {
      const response = await AddStaff(
        fullName,
        contact,
        department,
        Gender,
        designation,
        address,
        isAvailable,
        CommunityId,
        base64Image,
        DeputationSkills
      );
      if (response?.data?.ServerMessage === "Staff added successfully.") {
        onSubmit(); // Handle new data
      }
    } else {
      const response = await updateStaffInDataBase(
        fullName,
        contact,
        department,
        Gender,
        designation,
        base64Image,
        address,
        CommunityId,
        isAvailable,
        Staff.StaffId
      );
      if (response.data.ServerMessage === "Staff updated successfully.") {
        onSubmit(); // Handle new data
      }
    }
  };

  const validateImage = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) return reject("No file selected");

      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/gif",
        "image/webp",
      ];
      if (!allowedTypes.includes(file.type)) {
        return reject("Only jpeg, png, jpg, gif, webp images are allowed");
      }

      // if (file.size > 100 * 1024) {
      //   return reject("Image must be ≤ 100KB");
      // }

      const img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = () => {
        resolve();
        // if (img.width === 128 && img.height === 128) {
        //   resolve();
        // } else {
        //   reject("Image must be exactly 128x128 pixels");
        // }
      };

      img.onerror = () => reject("Invalid image file");
    });
  };

  const handleImageChange = async (file) => {
    if (!file) return;

    try {
      await validateImage(file);
      setPreviewUrl(URL.createObjectURL(file));

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result.split(",")[1];
        setBase64Image(base64String);
        setPreviewUrl(URL.createObjectURL(file));
      };

      setErrors({ ...errors, mobile_image: "" });
    } catch (err) {
      setErrors({ ...errors, mobile_image: err });
      setPreviewUrl(null);
      setBase64Image("");
    }
  };

  const handleNumbOfSkills = (e) => {
    console.log(e);

    const value = parseInt(e.target.value) || 0;
    setNoOfSkills(value);

    // Resize DeputationSkills array
    const updated = [...DeputationSkills];
    if (value > updated.length) {
      // Add empty values
      for (let i = updated.length; i < value; i++) {
        updated.push("");
      }
    } else {
      // Trim extra values
      updated.length = value;
    }
    setDeputationSkills(updated);
  };

  const handleSkillChange = (index, value) => {
    const updated = [...DeputationSkills];
    updated[index] = value;
    setDeputationSkills(updated);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] flex flex-col">
        {/* Modal Header */}
        <div className="flex justify-between items-center border-b px-6 pt-6 pb-3">
          <h2 className="text-2xl font-semibold text-blue-700 flex items-center gap-2">
            <svg
              className="w-6 h-6 text-blue-600"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                d="M12 4v16m8-8H4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            {Staff ? "Edit Deputy" : "Add Deputy"}
          </h2>
          <button
            onClick={closeModal}
            className="text-gray-400 hover:text-red-600 text-xl font-bold"
          >
            &times;
          </button>
        </div>

        {/* Scrollable Form Content */}
        <div className="overflow-y-auto px-6 pb-4 pt-2 scrollbar-hide">
          <form className="space-y-4">
            {/* Input Fields */}
            {[
              {
                label: "Full Name",
                value: fullName,
                onChange: (e) => setFullName(e.target.value),
                type: "text",
                placeholder: "Enter Full Name",
                required: true,
              },
              {
                label: "Contact",
                value: contact,
                onChange: (e) => setContact(e.target.value),
                type: "tel",
                required: true,
                pattern: "[6-9]{1}[0-9]{9}",
                maxLength: 10,

                placeholder: "Enter 10-digit phone number",
              },
              {
                label: "Department",
                value: department,
                onChange: (e) => setDepartment(e.target.value),
                required: true,
                placeholder: "Enter Department",
                type: "text",
              },
              {
                label: "Designation",
                value: designation,
                onChange: (e) => setDesignation(e.target.value),
                required: true,
                placeholder: "Enter Designation",
                type: "text",
              },
              {
                label: "Address",
                value: address,
                onChange: (e) => setAddress(e.target.value),
                required: true,
                placeholder: "Enter Address",
                type: "text",
              },
            ].map((field, i) => (
              <div key={i}>
                <label className="block text-sm font-medium text-gray-700">
                  {field.label} *
                </label>
                <input
                  {...field}
                  className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            ))}


                 <div>
              <label className="block text-sm font-medium text-gray-700">
                Gender *
              </label>
              <select
                value={Gender}
                onChange={(e) => setGender(e.target.value)}
                required
                className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select Gender</option>
                <option value={"Male"}>Male</option>
                <option value={"Female"}>Female</option>
              </select>
            </div>



            {/* isAvailable */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                isAvailable *
              </label>
              <select
                value={isAvailable}
                onChange={(e) => setisAvailable(e.target.value)}
                required
                className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select isAvailable</option>
                <option value={1}>Active</option>
                <option value={0}>Inactive</option>
              </select>
            </div>




            {/* Community */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Community *
              </label>
              <select
                value={CommunityId}
                onChange={(e) => setCommunityId(e.target.value)}
                required
                className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select Community</option>
                {communityList?.map((commu) => (
                  <option key={commu.CommunityId} value={commu.CommunityId}>
                    {commu.CommunityName}
                  </option>
                ))}
              </select>
            </div>

            {/* <div className="mb-2">
              <label className="block text-gray-700">No Of Skills *</label>
              <input
                type="number"
                value={NoOfSkills}
                onChange={handleNumbOfSkills}
                className="border border-gray-300 p-1 w-full rounded-md"
                required
              />
            </div>

            {DeputationSkills.map((skill, index) => (
              <div key={index} className="mb-2">
                <label className="block text-gray-700">
                  Skill for Deputation {index + 1} *
                </label>
                <select
                  value={skill}
                  onChange={(e) => handleSkillChange(index, e.target.value)}
                  className="border border-gray-300 p-1 w-full rounded-md"
                >
                  <option value="">Select Skill</option>
                  {SkillList.map((s, idx) => (
                    <option key={idx} value={s.SkillId}>
                      {s.SkillName}
                    </option>
                  ))}
                </select>
              </div>
            ))} */}

            {/* Image Upload */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Image *
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleImageChange(e.target.files[0])}
                className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm"
              />
              {previewUrl && (
                <div className="mt-2">
                  <img
                    src={previewUrl}
                    alt="Preview"
                    className="w-32 h-32 rounded-md border object-cover"
                  />
                </div>
              )}
              {errors.mobile_image && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.mobile_image}
                </p>
              )}
            </div>
          </form>
        </div>

        {/* Sticky Footer Buttons */}
        <div className="flex justify-end gap-3 border-t px-6 py-4 bg-white sticky bottom-0">
          <button
            type="button"
            onClick={closeModal}
            className="px-4 py-2 rounded-md border border-gray-400 text-gray-600 hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={handleFormSubmit}
            type="submit"
            form="yourFormId" // optional if you separate form
            className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700"
          >
            {Staff ? "Update" : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddStaffModal;
